// extracted by mini-css-extract-plugin
export var deleteModal = "_dw-0";